export const userActions = {
  MENU_USER: 'MENU_USER',
  MENU_ROLE: 'MENU_ROLE',
  MENU_CHANNEL: 'MENU_CHANNEL',
  USER_CREATE: 'USER_CREATE',
  USER_UPDATE: 'USER_UPDATE',
  USER_DELETE: 'USER_DELETE',
  USER_PASSWORD_CHANGE: 'USER_PASSWORD_CHANGE',
  USER_ACTIVATE: 'USER_ACTIVATE',
  USER_DEACTIVATE: 'USER_DEACTIVATE',
  USER_DEACTIVATE2FA: 'USER_DEACTIVATE2FA',
  USER_REGISTER2FA: 'USER_REGISTER2FA',
  ROLE_CREATE: 'ROLE_CREATE',
  ROLE_UPDATE: 'ROLE_UPDATE',
  ROLE_DELETE: 'ROLE_DELETE',
  CHANNEL_CREATE: 'CHANNEL_CREATE',
  CHANNEL_UPDATE: 'CHANNEL_UPDATE',
  CHANNEL_DELETE: 'CHANNEL_DELETE',
  MENU_AUDIT_LOGIN_EVENTS: 'MENU_AUDIT_LOGIN_EVENTS',
  MENU_AUDIT_HTTP_TRACE: 'MENU_AUDIT_HTTP_TRACE',
  ADMINISTRATION: 'ADMINISTRATION_FIND_ALL',
  MENU_ADMINISTRATION: 'MENU_ADMINISTRATION',
  ADMINISTRATION_FILTER_UPDATE: 'ADMINISTRATION_FILTER_UPDATE',
  ADMINISTRATION_TABLE_UPDATE: 'ADMINISTRATION_TABLE_UPDATE',
  ADMINISTRATION_TABLE_ACTIONS_UPDATE: 'ADMINISTRATION_TABLE_ACTIONS_UPDATE',
  ADMINISTRATION_FIND_ALL: 'ADMINISTRATION_FIND_ALL',
  MENU_AUTHORS_WORK: 'MENU_AUTHORS_WORK',
  MENU_MONITORING: 'MENU_MONITORING',
  USER_UNLOCK: 'USER_UNLOCK',
  UPLOAD_INSTRUCTION: 'UPLOAD_INSTRUCTION',
  CODEBOOK_TYPE_GROUP_UPDATE: 'CODEBOOK_TYPE_GROUP_UPDATE',
  CODEBOOK_TYPE_GROUP_DELETE: 'CODEBOOK_TYPE_GROUP_DELETE',
  CODEBOOK_TYPE_GROUP_CREATE: 'CODEBOOK_TYPE_GROUP_CREATE',
  CODEBOOK_TYPE_GROUP_FIND_ALL: 'CODEBOOK_TYPE_GROUP_FIND_ALL',
  MENU_CODE_CODEBOOK_TYPES: 'MENU_CODE_CODEBOOK_TYPES',
  CODEBOOK_TYPE_UPDATE: 'CODEBOOK_TYPE_UPDATE',
  CODEBOOK_TYPE_DELETE: 'CODEBOOK_TYPE_DELETE',
  CODEBOOK_TYPE_CREATE: 'CODEBOOK_TYPE_CREATE',
  CODEBOOK_TYPE_ACTIVATE: 'CODEBOOK_TYPE_ACTIVATE',
  CODEBOOK_TYPE_DEACTIVATE: 'CODEBOOK_TYPE_DEACTIVATE',
  CODEBOOK_FIND_ALL: 'CODEBOOK_FIND_ALL',
  CODEBOOK_CREATE: 'CODEBOOK_CREATE',
  CODEBOOK_UPDATE: 'CODEBOOK_UPDATE',
  CODEBOOK_DELETE: 'CODEBOOK_DELETE',
  CODEBOOK_ACTIVATE: 'CODEBOOK_ACTIVATE',
  CODEBOOK_DEACTIVATE: 'CODEBOOK_DEACTIVATE',
  CODEBOOK_COLUMN_CREATE: 'CODEBOOK_COLUMN_CREATE',
  CODEBOOK_COLUMN_UPDATE: 'CODEBOOK_COLUMN_UPDATE',
  CODEBOOK_COLUMN_DELETE: 'CODEBOOK_COLUMN_DELETE',
  CODEBOOK_SHOW_CHILDREN: 'CODEBOOK_SHOW_CHILDREN',
  MENU_COMPILATIONS: 'MENU_COMPILATIONS',
};
